import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment";

import SelectInput from "components/SelectInput";
import ButtonContained from "components/ButtonContained";
import ButtonIconOnly from "components/ButtonIconOnly";

import { userSignOut, userSignIn, forgotPassword } from "actions/Auth";
import {
  setLoginPerformance,
  submitNotificationPerformance,
  setErrorDetails
} from "actions/App";

const CompanySelect = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const loginPerformance = useSelector((state) => state.app.loginPerformance);
  const errorDetails = useSelector((state) => state.app.errorDetails);
  if (!(location.state && location.state.login)) {
    history.push("/signin");
    return null;
  }
  const { login, companies } = location.state;
  const [company, setCompany] = useState(
    localStorage.getItem("nse_login_data")
    ? JSON.parse(localStorage.getItem("nse_login_data")).companyUUID
    : companies[0].CompanyUUID
  );
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    document.title = "Company Select | Smart Entry";
  }, []);

  useEffect(() => {
    return () => {
      // Runs on unmount
      dispatch(setErrorDetails(null));
    };
  }, []);

  useEffect(() => {
    if (errorDetails) {
      setHasError(true);
      setErrorMessage(errorDetails.description);
    } else {
      setHasError(false);
      setErrorMessage("");
    }
  }, [errorDetails]);

  const submitLogin = (e) => {
    e.preventDefault();
    login.companyUUID = company;
    if (login.password == "" || !login.password) {
      dispatch(submitNotificationPerformance({
          site_id: parseInt(login.siteUUID),
          notification_id: login.phoneLogin ? login.phone : login.email,
          notification_type: "password_reset",
          notification_name: "password_reset",
          start_time: moment().utc()
      }));
      dispatch(forgotPassword(login));
    } else {
      dispatch(setLoginPerformance({
          ...loginPerformance,
          start_time: moment(),
          loginType: login.phoneLogin ? "Phone" : "Email",
          emailOrPhone: login.phoneLogin ? login.phone : login.email
      }));
      dispatch(userSignIn(login));
    }
  };

  const handleEnter = (e) => {
    if (e.keyCode == 13) {
      submitLogin(e);
    }
  };

  const clearError = () => {
    setHasError(false);
    setErrorMessage("");
  }

  return (
    <div className="h-full flex flex-col">
      <label className="flex justify-between items-center h-10">
        <h5 className="tw-heading-5 font-bold text-black">
          {intl.formatMessage({ id: "auth.company.header" })}
        </h5>
      </label>

      <div className="flex flex-col justify-between">
        <form onSubmit={(e) => submitLogin(e)} onKeyDown={(e) => handleEnter(e)}>
          <div className="flex justify-between items-center gap-2 mt-6 mb-16 w-full">
            <SelectInput
              id="Company-Select-Select-Company"
              dataCy="Company-Select-Select-Company"
              value={company || ""}
              placeholder={intl.formatMessage({id: "form.selectCompany"})}
              onChange={(e) => {
                if (hasError) {
                  clearError();
                }
                setCompany(e.target.value);
              }}
              options={
                companies
                ? companies.map(company => ({
                  value: company.CompanyUUID,
                  name: company.CompanyName
                }))
                : []
              }
              hasError={hasError ? true : false}
              errorMessage={hasError ? errorMessage : null}
            />
            <ButtonIconOnly
              id="Company-Select-Submit-Button"
              data-cy="Company-Select-Submit-Button"
              icon="arrowRight"
              size={20}
              type="alt"
              buttonType="submit"
            />
          </div>
          <div className="flex justify-start">
            <ButtonContained
              id="Company-Select-Cancel-Button"
              dataCy="Company-Select-Cancel-Button"
              text={intl.formatMessage({id: "comp.button.cancel"})}
              type="default"
              onClick={(e) => {e.preventDefault(); dispatch(userSignOut())}}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default CompanySelect;